import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { DiscountARRule } from '@/models/discount-ar-rule'
import type { DiscountARRuleMaster } from '@/components/pages/setting/sales-manager/accounts-receivable-display'
import { DeleteIcon } from '@/components/molecules/settings/icon/delete-icon'
import { TableBody, TableHeader, TableRow } from '@/components/organisms/settings/sales-manager/table'

type Props = {
  rules: DiscountARRule[]
  master: DiscountARRuleMaster
  onDelete: (id: string) => void
  onEdit: (rule: DiscountARRule) => void
}

export const SettingDiscountARRuleList: React.FC<Props> = ({ rules, master, onDelete, onEdit }) => {
  const { t } = useTranslation()
  const hasMultiLineRow = (rule: DiscountARRule) => rule.details.length > 1

  return (
    <>
      <TableHeader css={tableStyle}>
        <div className="discount-col">{t('Discount subject name')}</div>
        <div className="target-col">{t('Discount AR Settings')}</div>
        <div className="detail-col">{`${t('Accounts receivable name')}・${t('AR Target')}`}</div>
        <div className="delete-col"></div>
      </TableHeader>
      <TableBody css={tableStyle}>
        {rules.map(rule => (
          <TableRow
            key={rule.id}
            className={`table-row ${hasMultiLineRow(rule) ? '-multi-line' : ''}`}
            css={[
              css({
                ...(hasMultiLineRow(rule)
                  ? {
                      alignItems: 'start',
                      padding: '18px 0',
                    }
                  : {}),
              }),
            ]}
            onClick={() => onEdit(rule)}
          >
            <div className="discount-col">{rule.discountName}</div>
            <div className="target-col">{rule.defaultTargetFlag ? t('Outstanding sales') : '-'}</div>
            <div className="detail-col">
              {rule.details.map(detail => (
                <div key={detail.arCode} className="item-row">
                  {`${detail.arName}・${detail.targetFlag ? t('Target') : t('Non target')}`}
                </div>
              ))}
            </div>
            <div className="delete-col" style={{ marginTop: hasMultiLineRow(rule) ? '-10px' : 'inherit' }}>
              <DeleteIcon onClick={() => onDelete(rule.id)} />
            </div>
          </TableRow>
        ))}
      </TableBody>
    </>
  )
}

const tableStyle = css({
  '.table-row': {
    '> div': { fontWeight: 500 },
    minHeight: 49,
  },
  '.discount-col': { marginLeft: 32, width: 180 },
  '.detail-col': { flexGrow: 1 },
  '.target-col': { width: 150 },
  '.item-row': { fontSize: 14, fontWeight: 500 },
  '.delete-col': { padding: '0 32px', width: 30 },
})
